const userMenus = [
	{
		id: 1,
		title: '企业中心',
		path: '/UserCenter/UserAccount',
		active: false,
		childs: [
			{ id: '1-1', title: '企业信息', path: '/UserCenter/UserAccount'},
			{ id: '1-2', title: '账户设置', path: '/UserCenter/UserInfo' },
			{ id: '1-3', title: '企业成员管理', path: '/UserCenter/SubAccount' },
			// { id: '1-5', title: '设置组别', path: '/UserCenter/AccountGroup' },
			{ id: '1-6', title: '收货地址', path: '/UserCenter/UserAddress' },
			{ id: '1-7', title: '发票信息', path: '/UserCenter/UserInvoice' }
		]
	},
	{
		id: 2,
		title: '我的订单',
		path: '/UserCenter/BookOrder',
		active: false,
		childs: [
			{ id: '2-1', title: '图书订单', path: '/UserCenter/BookOrder' },
			// { id: '2-2', title: 'VIP会员订单', path: '/UserCenter/VIPOrder' }
		]
	}
];

export default userMenus;
